const DeliveryIcon = ({ ...props }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.5889 7H12.3389L11.3789 15.685C11.5289 15.01 12.1289 14.5 12.8489 14.5C13.1767 14.5 13.4806 14.6069 13.7282 14.7871L14.5889 7Z"
        fill="#FB3973"
        fillOpacity="0.2"
      />
      <path
        d="M14.3678 16.002L14.3496 16H16.5996C17.3643 16 17.9955 15.4277 18.088 14.688L18.838 8.68795C18.8457 8.62637 18.8496 8.56364 18.8496 8.5C18.8496 7.67159 18.178 7 17.3496 7H12.3496"
        stroke="#663D20"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.65039 17.5C6.47882 17.5 7.15039 16.8284 7.15039 16C7.15039 15.1716 6.47882 14.5 5.65039 14.5C4.82196 14.5 4.15039 15.1716 4.15039 16C4.15039 16.8284 4.82196 17.5 5.65039 17.5Z"
        stroke="#663D20"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8496 17.5C13.678 17.5 14.3496 16.8284 14.3496 16C14.3496 15.1716 13.678 14.5 12.8496 14.5C12.0212 14.5 11.3496 15.1716 11.3496 16C11.3496 16.8284 12.0212 17.5 12.8496 17.5Z"
        stroke="#663D20"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.15039 8.5H4.15039"
        stroke="#FB3973"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.15039 5.5H5.65039"
        stroke="#FB3973"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.15039 11.5H2.65039"
        stroke="#FB3973"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.15039 16H11.3504L12.4802 5.83131C12.6777 4.05419 11.2866 2.5 9.4986 2.5H2.65039"
        stroke="#663D20"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.15039 16H2.65039C1.82198 16 1.15039 15.3284 1.15039 14.5"
        stroke="#663D20"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3692 7L15.0543 9.83433C14.9555 10.7229 15.6511 11.5 16.5451 11.5H18.4875"
        stroke="#663D20"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DeliveryIcon;
